<template>
  <div style="height: 100%">
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%; width: 100%">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="点位名称">
                <el-select
                  filterable
                  placeholder="请选择点位"
                  clearable
                  v-model="form.pointName"
                >
                  <el-option
                    v-for="item in treeData"
                    :key="item.id"
                    :label="item.pointName"
                    :value="item.pointName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="事项名称">
                <el-input
                  v-model="form.eventName"
                  clearable
                  placeholder="请输入事项名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="指标名称">
                <el-input
                  v-model="form.zbmc"
                  clearable
                  placeholder="请输入指标名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="巡查日期" required>
                <el-date-picker
                  v-model="form.handleTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="填报人部门一">
                <el-input
                  v-model="form.masterHandleDeptName"
                  clearable
                  placeholder="请输入填报人部门一"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="所属部门一">
                  <el-select
                    filterable
                    placeholder="请选择所属部门一"
                    clearable
                    v-model="form.masterHandleDeptName"
                  >
                    <el-option
                      v-for="item in tableDataRole"
                      :key="item.data.id"
                      :label="item.data.deptName"
                      :value="item.data.deptName"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
              <el-form-item label="巡查人员一">
                <el-input
                  v-model="form.masterHandleUserName"
                  clearable
                  placeholder="请输入巡查人员一"
                ></el-input>
              </el-form-item>
              <el-form-item label="填报人部门二">
                <el-input
                  v-model="form.handleDeptName2"
                  clearable
                  placeholder="请输入填报人部门二"
                ></el-input>
              </el-form-item>
              <el-form-item label="巡查人员二">
                <el-input
                  v-model="form.handleUserName2"
                  clearable
                  placeholder="请输入巡查人员二"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否仅看不同">
                <el-select
                  filterable
                  placeholder="请选择"
                  clearable
                  v-model="form.onlyDiffFlag"
                >
                  <el-option
                    v-for="item in tableDataRules"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">比对</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn"></div>
          <div class="right-btn">
            <el-button
              @click="exportAllDetail"
              icon="el-icon-download"
              class="search"
              >导出</el-button
            >
          </div>
        </div>
        <el-table
          :data="dataList.tableData"
          style="width: 100%"
          :max-height="580"
          stripe
          border
          :header-row-style="headerRowStyle"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          :cell-style="cellStyle"
          v-loading="isLoading"
        >
          <el-table-column prop="pointName" label="点位名称"> </el-table-column>
          <el-table-column prop="eventName" label="事项名称"> </el-table-column>

          <el-table-column prop="zbmc" label="指标名称"> </el-table-column>
          <el-table-column prop="masterHandleDeptName" label="填报人部门一">
          </el-table-column>
          <el-table-column prop="masterHandleUserName" label="巡查人员一">
          </el-table-column>
          <el-table-column prop="masterHandleTime" label="巡查时间">
          </el-table-column>
          <el-table-column prop="masterHandleStatus" label="巡查结果">
            <template slot-scope="scope">
              <span
                :class="[
                  scope.row.masterHandleStatus != scope.row.handleStatus2
                    ? 'master-handle'
                    : ''
                ]"
                >{{
                  scope.row.masterHandleStatus == "符合"
                    ? "是"
                    : scope.row.masterHandleStatus == "不符合"
                    ? "否"
                    : scope.row.masterHandleStatus
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="handleDeptName2" label="填报人部门二">
          </el-table-column>
          <el-table-column prop="handleUserName2" label="巡查人员二">
          </el-table-column>
          <el-table-column prop="handleTime2" label="巡查时间">
          </el-table-column>
          <el-table-column prop="handleStatus2" label="巡查结果">
            <template slot-scope="scope">
              <span
                :class="[
                  scope.row.masterHandleStatus != scope.row.handleStatus2
                    ? 'master-handle'
                    : ''
                ]"
                >{{
                  scope.row.handleStatus2 == "符合"
                    ? "是"
                    : scope.row.handleStatus2 == "不符合"
                    ? "否"
                    : scope.row.handleStatus2
                }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="blockList" v-if="dataList.tableData.length">
          <div class="noRate">不一致率 {{ buyizhiRate }}</div>
          <el-pagination
            layout="total"
            :total="Number(dataList.tableData.length)"
            background
            :style="{ textAlign: 'right' }"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { taskIndexFlowSqComp, sqCompExp } from "@/api/task.js";
import { getPointLevelListPage } from "@/api/point.js";
export default {
  data() {
    return {
      headerRowStyle: {
        background: "none",
        color: "#647196"
      },
      headerCellStyle: {
        background: "#F1F4F6",
        color: "#3D4042",
        height: "56px",
        fontSize: "16px",
        padding: "0"
      },
      rowStyle: {
        background: "none",
        height: "56px",
        borderBottom: "1px solid #D9DCDE"
      },
      cellStyle: {
        background: "none",
        color: "#3D4042",
        fontSize: "16px",
        borderBottom: "1px solid #D9DCDE"
      },
      form: {
        eventName: "",
        handleTime: "",
        handleUserName2: "",
        masterHandleUserName: "",
        masterHandleDeptName: "",
        pointName: "",
        handleDeptName2: "",
        zbmc: "",
        onlyDiffFlag: ""
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: []
      },
      isLoading: false,
      tableDataRules: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      buyizhiRate: "0%",
      treeData: []
    };
  },
  mounted() {
    this.getPointLevelListFun();
  },
  methods: {
    async getPointLevelListFun() {
      const res = await getPointLevelListPage({
        page: 1,
        size: 9999999
      });
      this.treeData = res.data.data.records || [];
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.pointName = "";
      this.form.eventName = "";
      this.form.handleTime = "";
      this.form.handleUserName2 = "";
      this.form.onlyDiffFlag = "";
      this.form.masterHandleUserName = "";
      this.form.masterHandleDeptName = "";
      this.form.handleDeptName2 = "";
      this.form.zbmc = "";
      this.dataList.tableData = [];
    },
    // 分页查询
    getPointTypeListPageFun() {
      if (!this.form.handleTime) {
        this.$message.warning("请选择【巡查日期】后再进行比对");
        return;
      }
      this.isLoading = true;
      let params = {
        ...this.form
      };
      taskIndexFlowSqComp(params)
        .then(res => {
          if (res.data.code == 200) {
            this.dataList.tableData = res.data.data || [];
            let buyizhi = this.dataList.tableData.filter(
              item => item.handleStatus2 != item.masterHandleStatus
            );
            this.buyizhiRate =
              this.dataList.tableData.length == 0
                ? 0 + "%"
                : (buyizhi.length / this.dataList.tableData.length).toFixed(4) *
                    100 +
                  "%";
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    async exportAllDetail() {
      if (!this.form.handleTime) {
        this.$message.warning("请选择【巡查日期】后再进行比对");
        return;
      }
      const res = await sqCompExp({
        ...this.form,
      });
      if (res.status == 200) {
        this.exportLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${this.form.handleTime}关芯智巡巡查记录比对分析.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.flex-center {
  display: flex;
  justify-content: center;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

// /deep/ .el-table {
//   .el-table__body-wrapper {
//     .el-table_1_column_1,
//     .el-table_1_column_2 {
//       vertical-align: baseline;
//     }
//   }
// }
/deep/ .el-table {
  .inconsistent-row {
    background-color: red !important; /* 高亮颜色 */
  }
}
/deep/ .el-table {
  .master-handle {
    color: red;
  }
}

.blockList {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .noRate {
    margin-right: 10px;
    font-weight: 400;
    color: red;
    height: 32px;
    line-height: 32px;
    margin-top: -2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/comparisonInspectionRecords/list.vue